export default {
  firstLetterUppercase(string) {
    return string ? string.replace(/^\w/, character => character.toUpperCase()) : string;
  },

  addSpaces(string) {
    return string ? string.replace(/(([a-z])(?=[A-Z])|([A-Z])(?=[A-Z][a-z]))/g, '$1 ').trim() : string;
  },

  toKebabCase(string) {
    return string
      ? string
          .match(/[A-Z]{2,}(?=[A-Z][a-z0-9]*|\b)|[A-Z]?[a-z0-9]*|[A-Z]|[0-9]+/g)
          .filter(Boolean)
          .map(character => character.toLowerCase())
          .join('-')
      : string;
  },

  fieldToTitle(string) {
    return string ? this.fieldToTitleWithName(string).replace(' Name', '') : string;
  },

  fieldToTitleWithName(string) {
    return string ? this.globalReplacement(this.addSpaces(this.firstLetterUppercase(string))) : string;
  },

  globalReplacement(string) {
    return string
      ? string
          .replace('Third Party', 'Third-Party')
          .replace('Manufacturer Model', 'Manufacturer')
          .replace('Unit Of Measure', 'UofM')
          .replace('Is Billing', '$')
          .replace(/display/i, '')
          .trim()
      : string;
  }
};
